import { render, staticRenderFns } from "./template_edit.vue?vue&type=template&id=6f481b3d&"
import script from "./template_edit.vue?vue&type=script&lang=js&"
export * from "./template_edit.vue?vue&type=script&lang=js&"
import style0 from "./template_edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports